<div class="header-container">
  <h3>Administrators</h3>
  <div class="header-container-actions">
    <button matButton="elevated" class="charcoal-button" (click)="addSysAdmin()">ADD SYSADMIN</button>
    <button matIconButton (click)="administratorsExpanded.set(!administratorsExpanded())">
      <mat-icon>{{ administratorsExpanded() ? 'expand_less' : 'expand_more' }}</mat-icon>
    </button>
  </div>
</div>
<mat-divider />
@if (sysadminList()?.length) {
  <div [class.hidden]="!administratorsExpanded()" class="cards-container">
    @for (sysadmin of sysadminList(); track sysadmin.username) {
      <div class="admin-container">
        <mat-card class="sysadmin-card" (click)="addSysAdmin(sysadmin); $event.stopPropagation()">
          <div class="sysadmin-line body-2">
            <div class="sysadmin body-2">SYSADMIN</div>
          </div>
          <div class="sysadmin-line">
            <div>
              <div class="subtitle-1">{{ sysadmin.firstName }} {{ sysadmin.lastName }}</div>
              <div class="body-2">
                {{ sysadmin.emailAddress }}
              </div>
              <div class="body-2 username">
                {{ sysadmin.username }}
              </div>
            </div>
            <div class="secondary-icon">
              <button matIconButton (click)="$event.stopPropagation()" [matMenuTriggerFor]="enableDisableMenu">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #enableDisableMenu="matMenu" xPosition="before" class="kebab-menu sysadmin-kebab">
                @if ((sysadmin.status === 'ENABLED' || sysadmin.status === 'SUSPENDED') && sysadmin.isActivated) {
                  <button mat-menu-item (click)="enableDisableSysAdmin(sysadmin, false)">
                    <span>Disable User</span>
                  </button>
                }
                @if (sysadmin.isActivated && (sysadmin.status === 'DISABLED' || sysadmin.status === 'SUSPENDED')) {
                  <button mat-menu-item (click)="enableDisableSysAdmin(sysadmin, true)">
                    <span>Enable User</span>
                  </button>
                }
                @if (sysadmin.isActivated || sysadmin.status === 'DISABLED') {
                  <button mat-menu-item (click)="confirmArchiveSysAdmin(sysadmin.username)">
                    <span>Archive User</span>
                  </button>
                }
                @if (!sysadmin.isActivated) {
                  <button mat-menu-item (click)="confirmDeleteInvitedSysAdmin(sysadmin.username)">
                    <span>Delete</span>
                  </button>
                }
              </mat-menu>
            </div>
          </div>

          <status-chip
            class="absolute right-16 bottom-16"
            [status]="
              sysadmin.isActivated ? (sysadmin.status === 'ENABLED' ? 'ACTIVE' : sysadmin.status) : 'INVITED'
            " />
        </mat-card>
      </div>
    }
  </div>
}
